
import FaqItem from './-faq-item.vue'

export default {
  components: { FaqItem },
  props: {
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    allowToggleAll: {
      type: Boolean,
      default: true,
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isAllUnfolded: true,
      loading: false,
      finished: false,
      list: [],
      currentPage: 1,
      pageSize: 15,
      total: 0,
    }
  },
  computed: {
    // 切换全部展开、全部折叠状态
    toggleAllText() {
      return this.isAllUnfolded
        ? this.$t('button.expandAll')
        : this.$t('button.collapseAll')
    },
  },
  watch: {
    type() {
      this.reset()
    },
    dataSource: {
      handler(nv) {
        this.list = nv
      },
      deep: true
    }
  },
  mounted() {
    this.list = this.dataSource
  },
  methods: {
    toggleAll() {
      this.isAllUnfolded = !this.isAllUnfolded
      this.$emit('changeFolded', this.isAllUnfolded)
      this.list.forEach((i) => {
        this.$set(i, 'folded', this.isAllUnfolded)
      })
    },
    reset() {
      this.list = []
      this.finished = false
      this.currentPage = 1
      this.total = 0
      this.isAllUnfolded = true
      this.$emit('changeFolded', this.isAllUnfolded)
      this.getNoticeList()
    },
    async getNoticeList(params = {}) {
      try {
        const defaultParams = {
          current: this.currentPage,
          size: this.pageSize,
          type: this.type,
        }
        const res = await this.$API.support.getFrequentlyAskedQuestions(
          defaultParams
        )
        // 加载状态结束
        this.loading = false
        // 数据全部加载完成
        if (
          res?.total <= this.pageSize ||
          res?.total / this.pageSize <= this.currentPage
        ) {
          this.finished = true
        }
        this.currentPage++
        this.list = Array.isArray(res.records)
          ? this.list.concat(res.records)
          : this.list
        this.list.forEach((item) => {
          item.folded = this.isAllUnfolded
        })
      } catch (e) {
        // console.log(6666, e);
        // console.log('getLiveOrigin error', e)
      }
    },
    onLoad() {
      this.getNoticeList()
    },
  },
}
